export default "__VITE_ASSET__aff6eca5__"